import {Customer} from "../../domain/model/customer";
import {JobCareer} from "../../domain/model/job_career";
import {Project} from "../../domain/model/project";
import {MessageRoom} from "../../domain/model/message_room";
import {TJobCareerWithCustomerID} from "../../domain/repository/job_career_repository";
import {ClientBookmark} from "../../domain/model/client_bookmark";
import {SearchHighlight} from "../../domain/model/search_highlight";
import {Company} from "../../domain/model/company";
import { PastCaseProject } from "src/domain/model/past_case_project";

// client scout customer list
interface ISearchCustomerListByClientResponse {
    customers?: Customer[];
    customerCount?: number;
    jobCareersWithCustomerID?: TJobCareerWithCustomerID[];
    clientBookmarks?: ClientBookmark[];

}
class SearchCustomerListByClientResponse implements ISearchCustomerListByClientResponse {
    public customers: Customer[];
    public customerCount: number;
    public jobCareersWithCustomerID: TJobCareerWithCustomerID[];
    public clientBookmarks: ClientBookmark[];

}

// client scout customer detail
interface IGetCustomerByClientResponse {
    customer?: Customer;
    company?: Company;
    jobCareers?: JobCareer[];
    projects?: Project[];
    clientBookmarks?: ClientBookmark[];
    pastCaseProjects?: PastCaseProject[];
    sameOccupationCustomers?: Customer[];
    jobCareersWithSameOccupationCustomerID?: TJobCareerWithCustomerID[];

}
class GetCustomerByClientResponse implements IGetCustomerByClientResponse {
    public customer: Customer;
    public company: Company;
    public jobCareers: JobCareer[];
    public projects: Project[];
    public clientBookmarks: ClientBookmark[];
    public pastCaseProjects: PastCaseProject[];
    public sameOccupationCustomers: Customer[];
    public jobCareersWithSameOccupationCustomerID: TJobCareerWithCustomerID[];
}

interface ICreateScoutCustomerByClientResponse {
    messageRoom?: MessageRoom;

}
class CreateScoutCustomerByClientResponse implements ICreateScoutCustomerByClientResponse {
    public messageRoom: MessageRoom;

}

interface ICreateClientBookMarkByClientResponse {
    clientBookmarks?: ClientBookmark[];

}
class CreateClientBookmarkByClientResponse implements ICreateClientBookMarkByClientResponse {
    public clientBookmarks: ClientBookmark[];

}

interface IDeleteClientBookMarkByClientResponse {
    clientBookmarks?: ClientBookmark[];

}
class DeleteClientBookmarkByClientResponse implements IDeleteClientBookMarkByClientResponse {
    public clientBookmarks: ClientBookmark[];

}

interface ICopyHighlightsByClientResponse {
    highlights?: SearchHighlight[];
}
class CopyHighlightsByClientResponse implements ICopyHighlightsByClientResponse {
    public highlights: SearchHighlight[];
}

interface IDeleteHighlightsByClientResponse {
}
class DeleteHighlightsByClientResponse implements IDeleteHighlightsByClientResponse {
}

export {
    // client scout customer list
    SearchCustomerListByClientResponse,
    // client scout customer detail
    GetCustomerByClientResponse,
    CreateScoutCustomerByClientResponse,
    CreateClientBookmarkByClientResponse,
    DeleteClientBookmarkByClientResponse,
    CopyHighlightsByClientResponse,
    DeleteHighlightsByClientResponse,
}



// WEBPACK FOOTER //
// ./src/presentation/response/scout_response.ts